.menuBar {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: var(--color-bg-primary);
  border-bottom: 1px solid var(--color-border);
  box-shadow: var(--color-shadow-card);
  overflow-x: auto;
}

.inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1280px;
  min-width: max-content;
  margin: 0 auto;
  padding: 0 16px;
  height: 52px;
  gap: 12px;
  position: relative;
}

.logo {
  font-family: var(--font-family-base);
  font-size: 1.4rem;
  font-weight: bold;
  color: var(--color-text-primary);
  text-decoration: none;
  white-space: nowrap;
}

.logo:hover {
  text-decoration: none;
  color: var(--color-accent);
}

.faqLink {
  font-size: 0.875rem;
  color: var(--color-text-secondary);
  text-decoration: none;
  white-space: nowrap;
  transition: border-color 0.2s, color 0.2s, background-color 0.2s;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  padding: 6px 14px;
  background-color: var(--color-bg-secondary);
  display: flex;
  align-items: center;
}

.faqLink:hover {
  color: var(--color-accent);
  border-color: var(--color-accent);
  text-decoration: none;
  background-color: var(--color-bg-tertiary);
}

.actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.themeBtn {
  background: none;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  cursor: pointer;
  color: var(--color-text-secondary);
  font-size: 1rem;
  padding: 6px 8px;
  line-height: 1.4;
  transition: border-color 0.2s, color 0.2s;
}

.themeBtn:hover {
  border-color: var(--color-accent);
  color: var(--color-accent);
}

.fontSizeSelect {
  background: none;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  cursor: pointer;
  color: var(--color-text-secondary);
  font-size: 0.8125rem;
  padding: 6px 6px;
  transition: border-color 0.2s, color 0.2s;
  font-family: inherit;
  background-color: var(--color-bg-primary);
}

.fontSizeSelect:hover {
  border-color: var(--color-accent);
  color: var(--color-accent);
}

.fontSizeSelect:focus {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

.loginBtn {
  background-color: var(--color-accent);
  color: var(--color-text-inverse);
  border: 1px solid transparent;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;
}

.loginBtn:hover {
  background-color: var(--color-accent-hover);
}

.userInfo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.username {
  font-size: 0.875rem;
  color: var(--color-text-secondary);
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profileLink {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  padding: 6px 8px;
  font-size: 1rem;
  line-height: 1.4;
  color: var(--color-text-secondary);
  text-decoration: none;
  transition: border-color 0.2s, color 0.2s;
}

.profileLink:hover {
  border-color: var(--color-accent);
  color: var(--color-accent);
  text-decoration: none;
}

.guestActions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.registerLink {
  font-size: 0.875rem;
  color: var(--color-text-secondary);
  border: 1px solid var(--color-border);
  border-radius: 6px;
  padding: 6px 14px;
  transition: border-color 0.2s, color 0.2s;
  white-space: nowrap;
}

.registerLink:hover {
  border-color: var(--color-accent);
  color: var(--color-accent);
  text-decoration: none;
}

/* ---- Legal links (Impressum, Privacy) ---- */

.legalLinks {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-left: 4px;
}

.legalLink {
  font-size: 0.65rem;
  color: var(--color-text-tertiary);
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.2s;
  line-height: 1.2;
}

.legalLink:hover {
  color: var(--color-text-secondary);
  text-decoration: underline;
}

/* ---- Token-refresh status badge ---- */

@keyframes refreshPulse {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.55; }
}

.refreshingStatus {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;

  display: inline-flex;
  align-items: center;
  gap: 6px;

  padding: 3px 12px;
  border-radius: 999px;
  border: 1px solid var(--color-accent);
  background-color: var(--color-accent-subtle);
  color: var(--color-accent);

  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  letter-spacing: 0.01em;

  animation: refreshPulse 1.4s ease-in-out infinite;
}

.refreshingDot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--color-accent);
  flex-shrink: 0;
}
